import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CardBrand, PaymentMethod } from '../../../../../models/interfaces/god-orders.interface';

const METHOD_ICONS: Partial<Record<PaymentMethod, string>> = {
  klarna: 'klarna',
  apple_pay: 'apple-pay',
  google_pay: 'g-pay',
  paypal: 'paypal',
  bank: 'pay-bank',
  financing: 'pay-spain-financing'
};

const BRAND_ICONS: Partial<Record<CardBrand, string>> = {
  visa: 'pay-visa',
  mastercard: 'pay-mastercard'
};

const GENERIC_CARD_ICON = 'pay-credit-card';

/** Payment method of a purchase: icon (card brand when known, generic card otherwise) plus its label. */
@Component({
  selector: 'app-payment-method-cell',
  imports: [TranslatePipe],
  templateUrl: './payment-method-cell.component.html',
  styleUrl: './payment-method-cell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentMethodCellComponent {
  readonly method = input.required<PaymentMethod>();
  readonly cardBrand = input<CardBrand | null>(null);
  /** Pedidos aligns the cell to the left (Figma 30316); Suscripciones and the link modal centre it. */
  readonly align = input<'start' | 'center'>('center');

  protected readonly icon = computed<string | null>(() => {
    const method = this.method();
    if (method === 'card') {
      return BRAND_ICONS[this.cardBrand() ?? 'unknown'] ?? GENERIC_CARD_ICON;
    }
    return METHOD_ICONS[method] ?? null;
  });
  protected readonly isGenericCard = computed(() => this.icon() === GENERIC_CARD_ICON);
}
